import { enumWidgetType } from "./widgetTypes";

export const StonlyWidget = {
  type: enumWidgetType.stonly,

  // eslint-disable-next-line no-unused-vars
  Load(widgetConfig, context) {
    const widgetId = widgetConfig?.config?.widgetId;
    if (!widgetId) {
      console.warn("[StonlyWidget] No widgetId in config, skipping");
      return false;
    }

    if (window.StonlyWidget) {
      return true;
    }

    window.STONLY_WID = widgetId;

    (function (e, t, n, s) {
      e.StonlyWidget ||
        ((e.StonlyWidget = function () {
          e.StonlyWidget._api
            ? e.StonlyWidget._api.apply(e.StonlyWidget, arguments)
            : e.StonlyWidget.queue.push(arguments);
        }),
        (e.StonlyWidget.scriptPath = s),
        (e.StonlyWidget.apiPath = undefined),
        (e.StonlyWidget.sPath = undefined),
        (e.StonlyWidget.queue = []),
        (function () {
          const p = t.createElement(n);
          p.async = true;
          const c = new window.XMLHttpRequest();
          c.open("GET", s + "version?v=" + Date.now(), true);
          c.onreadystatechange = function () {
            if (c.readyState === 4) {
              p.src = s + "stonly-widget.js?v=" + (c.status === 200 ? c.responseText : Date.now());
              const i = t.getElementsByTagName(n)[0];
              i.parentNode.insertBefore(p, i);
            }
          };
          c.send();
        })());
    })(window, document, "script", "https://stonly.com/js/widget/v2/");

    return true;
  }
};
